import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Settings() {
  const { t, i18n } = useTranslation();

  const setLang = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{t('settings.title')}</h1>
      <div className="bg-gray-800 rounded-xl p-5 max-w-md">
        <div>
          <label className="text-gray-400 text-sm block mb-2">{t('settings.language')}</label>
          <div className="flex gap-2">
            <button onClick={() => setLang('en')}
              className={`px-4 py-2 rounded transition-colors ${i18n.language === 'en' ? 'bg-blue-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}`}>
              English
            </button>
            <button onClick={() => setLang('no')}
              className={`px-4 py-2 rounded transition-colors ${i18n.language === 'no' ? 'bg-blue-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}`}>
              Norsk
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
